import { CsvExportParams } from 'ag-grid-community';

export function exportToCSV(fileName: string): CsvExportParams {
  return {
    allColumns: false,
    columnSeparator: ',',
    // the `\n` is necessary, otherwise it will attach to the last cell
    // customFooter: '\nExported from Benzinga Pro',
    fileName: `${fileName}.csv`,
    onlySelected: false,
    onlySelectedAllPages: false,
    //skipFooters: true,
    skipColumnGroupHeaders: false,
    skipColumnHeaders: false,
    suppressQuotes: false,
  };
}
